import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './redux/_common/api.utils'; // side-effect: install axios interceptors

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
